import React from "react";
import { useParams } from "react-router-dom";
import Schools from "./Schools";
import SchoolDetail from "./SchoolDetail";

// /schools/:param → decide: `in-<city>` shows filtered listing, else detail page
export default function SchoolsRouteResolver() {
  const { param } = useParams();
  if (param && param.startsWith("in-")) return <Schools />;
  return <SchoolDetail />;
}
